import React from 'react';
import {
  useNavigate,
  useLocation,
  useParams,
} from 'react-router';

/**
 * withRouter is deprecated in react-router
 * Recreate using the hook
 */
function withRouter(Component) {
  function Wrapper(props) {
    const history = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
      <Component
        history={history}
        location={location}
        params={params}
        {...props}
      />
    );
  }

  return Wrapper;
}

export default withRouter;
